export function getNormalizedIndianPhone(phone) {
  const digits = String(phone || "").replace(/\D/g, "");

  if (digits.length === 12 && digits.startsWith("91")) return digits.slice(2);
  if (digits.length === 11 && digits.startsWith("0")) return digits.slice(1);

  return digits;
}

export function isValidIndianPhone(phone) {
  return /^[6-9]\d{9}$/.test(getNormalizedIndianPhone(phone));
}

export function validateDemoEnquiryForm(values) {
  if (!values.name?.trim()) return "Name is required.";
  if (!values.email?.trim()) return "Email is required.";
  if (!values.phone?.trim()) return "Phone number is required.";
  if (!isValidIndianPhone(values.phone)) return "Please enter a valid 10 digit Indian phone number.";
  if (!values.experienceLevel) return "Please select your experience level.";
  if (!values.courseInterest) return "Please select your course interest.";

  return "";
}
